import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { recruiterAPI } from '@/services/api';

export default function RecruiterProfileSetup() {
  const [form, setForm] = useState({ name: '', position: '', organization_name: '', organization_domain: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await recruiterAPI.createProfile(form);
      navigate('/recruiter');
    } catch (err) { setError(err.response?.data?.detail || err.message); }
    setLoading(false);
  };

  return (
    <div data-testid="recruiter-profile-setup" className="max-w-lg">
      <h1 className="text-2xl font-semibold text-slate-900 dark:text-white mb-6">Set Up Your Profile</h1>
      {error && <div className="bg-red-500/10 text-red-600 dark:text-red-400 px-4 py-2 rounded-lg mb-4 text-sm">{error}</div>}
      <form onSubmit={handleSubmit} className="space-y-4">
        {[['name', 'Full Name'], ['position', 'Position/Title'], ['organization_name', 'Organization Name'], ['organization_domain', 'Organization Domain (optional)']].map(([k, l]) => (
          <div key={k}>
            <label className="block text-sm text-slate-500 dark:text-zinc-400 mb-1">{l}</label>
            <input value={form[k]} onChange={e => setForm({ ...form, [k]: e.target.value })} required={k !== 'organization_domain'} className="w-full bg-white dark:bg-[#111114] border border-slate-200 dark:border-zinc-800 rounded-lg px-3 py-2.5 text-slate-900 dark:text-white text-sm placeholder-slate-400 dark:placeholder-zinc-600 focus:outline-none focus:border-slate-300 dark:focus:border-zinc-600" />
          </div>
        ))}
        <button type="submit" disabled={loading} className="w-full py-2.5 bg-slate-900 dark:bg-white text-white dark:text-black rounded-lg text-sm font-medium" data-testid="create-profile-btn">{loading ? 'Creating...' : 'Create Profile'}</button>
      </form>
    </div>
  );
}
